import axios from "axios"

export default {
    async Login(data){
        const response = await axios.post("/api/auth/login",data)
        return response
    },
    async RefreshToken(data){
        const response = await axios.post(`/api/auth/refreshtoken/${data}`)
        return response
    },
    async ForgotPassword(email){
        const response = await axios.get(`/api/auth/forgetpassword/${email}`)
        return response
    },
    async RecoveryPassword(data){
        const response = await axios.post('/api/auth/recoverypassword',data)
        return response
    }
}